import { render } from "./StatCard.vue?vue&type=template&id=5517ae6b&scoped=true"
import script from "./StatCard.vue?vue&type=script&lang=js"
export * from "./StatCard.vue?vue&type=script&lang=js"

import "./StatCard.vue?vue&type=style&index=0&id=5517ae6b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5517ae6b"]])

export default __exports__